import ColorLibrary from 'APP/Themes/ColorLibrary.json'
import { DefaultTheme } from 'styled-components/native'
import { baseTheme, baseColors } from './themeUtils'

export const diaLight: DefaultTheme = {
  name: 'Dia Light',
  ...baseTheme,
  colors: baseColors,
}

export const diaDark: DefaultTheme = {
  name: 'Dia Dark',
  ...baseTheme,
  colors: {
    ...baseColors,
    background: ColorLibrary.charcoal,
    primary: ColorLibrary.linen,
    secondary: ColorLibrary.linen,
    accent: ColorLibrary.peach,
    gradientStart: ColorLibrary.peach,
    gradientEnd: ColorLibrary.sky,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    elementBgError: ColorLibrary.chestnut,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    serviceIconPrimary: ColorLibrary.linen,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.peach,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    selected: ColorLibrary.dimGray,
    welcomeScreenSlideCurrentDot: ColorLibrary.linen,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide1: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide2: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide3: ColorLibrary.charcoal,

    // Text Colours
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    primaryText: ColorLibrary.charcoal,
    secondaryText: ColorLibrary.linen,
    errorText: ColorLibrary.alert,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,

    //  Button Colours
    buttonPrimary: ColorLibrary.linen,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryText: ColorLibrary.charcoal,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.linen,
    buttonSecondaryText: ColorLibrary.linen,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryDisabled: ColorLibrary.silver,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.peach,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.sky,
    buttonSelected: ColorLibrary.darkSlate,
    buttonProfile: ColorLibrary.darkSlate,
  },
}

export const canadalifeLight: DefaultTheme = {
  name: 'Canada Life Light',
  ...baseTheme,
  colors: {
    ...baseColors,
    primary: ColorLibrary.firebrick,
    primaryText: ColorLibrary.linen,
    secondary: ColorLibrary.charcoal,
    accent: ColorLibrary.firebrick,
    selected: ColorLibrary.blush,
    gradientStart: ColorLibrary.firebrick,
    gradientEnd: ColorLibrary.snow,
    patientMsgBg: ColorLibrary.blush,
    clientCardBg: ColorLibrary.blush,
    serviceIconPrimary: ColorLibrary.firebrick,
    serviceIconAccent: ColorLibrary.firebrick,
    bannerBg: ColorLibrary.blush,
    link: ColorLibrary.firebrick,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.blush,
    serviceDetailCardAccentBg: ColorLibrary.firebrick,
    serviceDetailCardText: ColorLibrary.firebrick,
    serviceDetailCardAccentText: ColorLibrary.linen,
    welcomeScreenSlideCurrentDot: ColorLibrary.firebrick,
    welcomeScreenSlideInvertedDot: ColorLibrary.silver,
    welcomeScreenBackgroundSlide0: ColorLibrary.spearmint,
    welcomeScreenBackgroundSlide1: ColorLibrary.cottonCandy,
    welcomeScreenBackgroundSlide2: ColorLibrary.honeydew,
    welcomeScreenBackgroundSlide3: ColorLibrary.banana,

    // Button Colours
    buttonPrimary: ColorLibrary.firebrick,

    // Slider Colours
    sliderPrimary: ColorLibrary.firebrick,

    // TODO: Refactor/Deprecate
    buttonSecondaryActive: ColorLibrary.blush,
  },
}

export const canadalifeDark: DefaultTheme = {
  name: 'Canada Life Dark',
  ...baseTheme,
  colors: {
    ...baseColors,
    background: ColorLibrary.charcoal,
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    primary: ColorLibrary.crimson,
    primaryText: ColorLibrary.charcoal,
    secondary: ColorLibrary.linen,
    errorText: ColorLibrary.alert,
    gradientStart: ColorLibrary.firebrick,
    gradientEnd: ColorLibrary.snow,
    accent: ColorLibrary.crimson,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    patientMsgBg: ColorLibrary.blush,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    serviceIconPrimary: ColorLibrary.white,
    serviceIconAccent: ColorLibrary.white,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.crimson,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,
    selected: ColorLibrary.dimGray,
    welcomeScreenSlideCurrentDot: ColorLibrary.crimson,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide1: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide2: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide3: ColorLibrary.charcoal,

    // Button Colours
    buttonPrimary: ColorLibrary.crimson,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.linen,
    buttonSecondaryText: ColorLibrary.linen,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.crimson,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSelected: ColorLibrary.darkSlate,
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.blush,
  },
}

export const sunlifeLight: DefaultTheme = {
  name: 'Sun Life Light',
  ...baseTheme,
  colors: {
    ...baseColors,
    primary: ColorLibrary.navyBlue,
    primaryText: ColorLibrary.linen,
    secondary: ColorLibrary.charcoal,
    accent: ColorLibrary.navyBlue,
    selected: ColorLibrary.lightBlue,
    gradientStart: ColorLibrary.teal,
    gradientEnd: ColorLibrary.sky,
    patientMsgBg: ColorLibrary.lightBlue,
    clientCardBg: ColorLibrary.lightBlue,
    serviceIconPrimary: ColorLibrary.navyBlue,
    serviceIconAccent: ColorLibrary.navyBlue,
    bannerBg: ColorLibrary.lightBlue,
    link: ColorLibrary.navyBlue,
    appointmentDateElement: ColorLibrary.lightBlue,
    serviceDetailCardBg: ColorLibrary.lightBlue,
    serviceDetailCardAccentBg: ColorLibrary.navyBlue,
    serviceDetailCardText: ColorLibrary.navyBlue,
    serviceDetailCardAccentText: ColorLibrary.linen,
    welcomeScreenSlideCurrentDot: ColorLibrary.navyBlue,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.canary,
    welcomeScreenBackgroundSlide1: ColorLibrary.canary,
    welcomeScreenBackgroundSlide2: ColorLibrary.canary,
    welcomeScreenBackgroundSlide3: ColorLibrary.canary,

    // Button Colours
    buttonPrimary: ColorLibrary.navyBlue,

    // Slider Colours
    sliderPrimary: ColorLibrary.navyBlue,

    // TODO: Refactor/Deprecate
    buttonSecondaryActive: ColorLibrary.lightBlue,
  },
}

export const sunlifeDark: DefaultTheme = {
  name: 'Sun Life Dark',
  ...baseTheme,
  colors: {
    ...baseColors,
    background: ColorLibrary.charcoal,
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    primary: ColorLibrary.teal,
    primaryText: ColorLibrary.charcoal,
    secondary: ColorLibrary.linen,
    accent: ColorLibrary.teal,
    selected: ColorLibrary.dimGray,
    errorText: ColorLibrary.alert,
    gradientStart: ColorLibrary.teal,
    gradientEnd: ColorLibrary.sky,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    patientMsgBg: ColorLibrary.lightBlue,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    serviceIconPrimary: ColorLibrary.teal,
    serviceIconAccent: ColorLibrary.teal,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.teal,
    appointmentDateElement: ColorLibrary.lightBlue,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,
    welcomeScreenSlideCurrentDot: ColorLibrary.teal,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.cyprus,
    welcomeScreenBackgroundSlide1: ColorLibrary.cyprus,
    welcomeScreenBackgroundSlide2: ColorLibrary.cyprus,
    welcomeScreenBackgroundSlide3: ColorLibrary.cyprus,

    // Button Colours
    buttonPrimary: ColorLibrary.teal,
    buttonPrimaryText: ColorLibrary.charcoal,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.linen,
    buttonSecondaryText: ColorLibrary.linen,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.teal,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.lightBlue,
    buttonSelected: ColorLibrary.darkSlate,
  },
}

//-- Rebrand Sunlife theme
export const sunlifeLight_v2: DefaultTheme = {
  name: 'Sun Life Light v2',
  ...baseTheme,
  fonts: {
    ...baseTheme.fonts,
    textTransform: {
      button: 'capitalize',
    },
  },
  colors: {
    ...baseColors,
    primary: ColorLibrary.britishRacingGreen,
    secondary: ColorLibrary.charcoal,
    background: ColorLibrary.white,
    accent: ColorLibrary.britishRacingGreen,
    selected: ColorLibrary.steel,
    gradientStart: ColorLibrary.britishRacingGreen,
    gradientEnd: ColorLibrary.britishRacingGreen,
    clientCardBg: ColorLibrary.steel,
    patientMsgBg: ColorLibrary.steel,
    serviceIconPrimary: ColorLibrary.charcoal,
    serviceIconAccent: ColorLibrary.charcoal,
    bannerBg: ColorLibrary.steel,
    link: ColorLibrary.seaBlue,
    appointmentDateElement: ColorLibrary.steel,
    serviceDetailCardBg: ColorLibrary.steel,
    serviceDetailCardAccentBg: ColorLibrary.britishRacingGreen,
    serviceDetailCardText: ColorLibrary.britishRacingGreen,
    serviceDetailCardAccentText: ColorLibrary.linen,

    welcomeScreenSlideCurrentDot: ColorLibrary.britishRacingGreen,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.cornSilk,
    welcomeScreenBackgroundSlide1: ColorLibrary.cornSilk,
    welcomeScreenBackgroundSlide2: ColorLibrary.cornSilk,
    welcomeScreenBackgroundSlide3: ColorLibrary.cornSilk,

    // Button Colours
    buttonPrimary: ColorLibrary.britishRacingGreen,
    buttonPrimaryTextDisabled: ColorLibrary.white,

    // Slider Colours
    sliderPrimary: ColorLibrary.britishRacingGreen,

    // TODO: Refactor/Deprecate
    buttonSecondaryActive: ColorLibrary.steel,
  },
}

export const sunlifeDark_v2: DefaultTheme = {
  name: 'Sun Life Dark v2',
  ...baseTheme,
  fonts: {
    ...baseTheme.fonts,
    textTransform: {
      button: 'capitalize',
    },
  },
  colors: {
    ...baseColors,
    background: ColorLibrary.charcoal,
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    primary: ColorLibrary.cornSilk,
    primaryText: ColorLibrary.charcoal,
    secondary: ColorLibrary.linen,
    accent: ColorLibrary.cornSilk,
    selected: ColorLibrary.dimGray,
    errorText: ColorLibrary.alert,
    gradientStart: ColorLibrary.cornSilk,
    gradientEnd: ColorLibrary.cornSilk,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    patientMsgBg: ColorLibrary.steel,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    serviceIconPrimary: ColorLibrary.cornSilk,
    serviceIconAccent: ColorLibrary.cornSilk,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.cornSilk,
    appointmentDateElement: ColorLibrary.steel,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,

    welcomeScreenSlideCurrentDot: ColorLibrary.cornSilk,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.britishRacingGreen,
    welcomeScreenBackgroundSlide1: ColorLibrary.britishRacingGreen,
    welcomeScreenBackgroundSlide2: ColorLibrary.britishRacingGreen,
    welcomeScreenBackgroundSlide3: ColorLibrary.britishRacingGreen,

    // Button Colours
    buttonPrimary: ColorLibrary.cornSilk,
    buttonPrimaryText: ColorLibrary.charcoal,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.linen,
    buttonSecondaryText: ColorLibrary.linen,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.cornSilk,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.cornSilk,
    buttonSelected: ColorLibrary.darkSlate,
  },
}
//---

export const sunlifeusLight: DefaultTheme = {
  name: 'Sun Life US Light',
  ...baseTheme,
  colors: {
    ...baseColors,
    primary: ColorLibrary.sunLifeBlue,
    primaryText: ColorLibrary.linen,
    secondary: ColorLibrary.charcoal,
    textInverted: ColorLibrary.sunLifeWarmYellow,
    accent: ColorLibrary.sunLifeBlue,
    selected: ColorLibrary.lightBlue,
    gradientStart: ColorLibrary.sunLifeBlue,
    gradientEnd: ColorLibrary.snow,
    patientMsgBg: ColorLibrary.lightBlue,
    clientCardBg: ColorLibrary.lightBlue,
    serviceIconPrimary: ColorLibrary.sunLifeBlue,
    serviceIconAccent: ColorLibrary.sunLifeBlue,
    bannerBg: ColorLibrary.lightBlue,
    link: ColorLibrary.sunLifeBlue,
    appointmentDateElement: ColorLibrary.sunLifeWarmYellow,
    serviceDetailCardBg: ColorLibrary.lightBlue,
    serviceDetailCardAccentBg: ColorLibrary.sunLifeBlue,
    serviceDetailCardText: ColorLibrary.sunLifeBlue,
    serviceDetailCardAccentText: ColorLibrary.sunLifeWarmYellow,
    welcomeScreenSlideCurrentDot: ColorLibrary.sunLifeBlue,
    welcomeScreenSlideInvertedDot: ColorLibrary.silver,
    welcomeScreenBackgroundSlide0: ColorLibrary.sunLifeWarmYellow,
    welcomeScreenBackgroundSlide1: ColorLibrary.sunLifeWarmYellow,
    welcomeScreenBackgroundSlide2: ColorLibrary.sunLifeWarmYellow,
    welcomeScreenBackgroundSlide3: ColorLibrary.sunLifeWarmYellow,

    // Button Colours
    buttonPrimary: ColorLibrary.sunLifeBlue,
    buttonPrimaryText: ColorLibrary.sunLifeWarmYellow,

    // Slider Colours
    sliderPrimary: ColorLibrary.sunLifeBlue,
    sliderSecondary: ColorLibrary.sunLifeWarmYellow,

    // TODO: Refactor/Deprecate
    buttonSecondaryActive: ColorLibrary.lightBlue,
  },
}

export const sunlifeusDark: DefaultTheme = {
  name: 'Sun Life US Dark',
  ...baseTheme,
  colors: {
    ...baseColors,
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    background: ColorLibrary.charcoal,
    primary: ColorLibrary.sunLifeYellow,
    primaryText: ColorLibrary.sunLifeBlue,
    secondary: ColorLibrary.sunLifeYellow,
    accent: ColorLibrary.sunLifeYellow,
    selected: ColorLibrary.dimGray,
    errorText: ColorLibrary.alert,
    gradientStart: ColorLibrary.sunLifeYellow,
    gradientEnd: ColorLibrary.snow,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    patientMsgBg: ColorLibrary.lightBlue,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    serviceIconPrimary: ColorLibrary.sunLifeYellow,
    serviceIconAccent: ColorLibrary.sunLifeYellow,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.sunLifeYellow,
    appointmentDateElement: ColorLibrary.sunLifeWarmYellow,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,
    welcomeScreenSlideCurrentDot: ColorLibrary.sunLifeYellow,
    welcomeScreenSlideInvertedDot: ColorLibrary.snow,
    welcomeScreenBackgroundSlide0: ColorLibrary.sunLifeBlue,
    welcomeScreenBackgroundSlide1: ColorLibrary.sunLifeBlue,
    welcomeScreenBackgroundSlide2: ColorLibrary.sunLifeBlue,
    welcomeScreenBackgroundSlide3: ColorLibrary.sunLifeBlue,

    // Button Colours
    buttonPrimary: ColorLibrary.sunLifeYellow,
    buttonPrimaryText: ColorLibrary.sunLifeBlue,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.sunLifeYellow,
    buttonSecondaryText: ColorLibrary.sunLifeYellow,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.sunLifeYellow,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSelected: ColorLibrary.darkSlate,
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.lightBlue,
  },
}

export const howdenLight: DefaultTheme = {
  name: 'howden Light',
  ...baseTheme,
  colors: {
    ...baseColors,
    primary: ColorLibrary.mcKenzie,
    accent: ColorLibrary.mcKenzie,
    selected: ColorLibrary.blush,
    serviceIconPrimary: ColorLibrary.mcKenzie,
    serviceIconAccent: ColorLibrary.mcKenzie,
    bannerBg: ColorLibrary.blush,
    link: ColorLibrary.mcKenzie,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.blush,
    serviceDetailCardAccentBg: ColorLibrary.mcKenzie,
    serviceDetailCardText: ColorLibrary.mcKenzie,
    serviceDetailCardAccentText: ColorLibrary.blush,
    welcomeScreenSlideCurrentDot: ColorLibrary.mcKenzie,
    welcomeScreenSlideInvertedDot: ColorLibrary.silver,
    welcomeScreenBackgroundSlide0: ColorLibrary.spearmint,
    welcomeScreenBackgroundSlide1: ColorLibrary.cottonCandy,
    welcomeScreenBackgroundSlide2: ColorLibrary.honeydew,
    welcomeScreenBackgroundSlide3: ColorLibrary.banana,

    // Button Colours
    buttonPrimary: ColorLibrary.mcKenzie,

    // Slider Colours
    sliderPrimary: ColorLibrary.mcKenzie,

    // TODO: Refactor/Deprecate
    buttonSecondaryActive: ColorLibrary.blush,
  },
}

export const howdenDark: DefaultTheme = {
  name: 'howden Dark',
  ...baseTheme,
  colors: {
    ...baseColors,
    background: ColorLibrary.charcoal,
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    primary: ColorLibrary.husk,
    primaryText: ColorLibrary.charcoal,
    secondary: ColorLibrary.linen,
    accent: ColorLibrary.husk,
    selected: ColorLibrary.dimGray,
    errorText: ColorLibrary.alert,
    gradientStart: ColorLibrary.peach,
    gradientEnd: ColorLibrary.sky,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    serviceIconPrimary: ColorLibrary.husk,
    serviceIconAccent: ColorLibrary.husk,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.husk,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,
    welcomeScreenSlideCurrentDot: ColorLibrary.husk,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide1: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide2: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide3: ColorLibrary.charcoal,

    // Button Colours
    buttonPrimary: ColorLibrary.husk,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.linen,
    buttonSecondaryText: ColorLibrary.linen,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.husk,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSelected: ColorLibrary.darkSlate,
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.blush,
  },
}

export const ccqLight: DefaultTheme = {
  name: 'ccq Light',
  ...baseTheme,
  colors: {
    ...baseColors,
    primary: ColorLibrary.raspberry,
    accent: ColorLibrary.raspberry,
    selected: ColorLibrary.blush,
    gradientStart: ColorLibrary.raspberryLight,
    gradientEnd: ColorLibrary.tealLight,
    serviceIconPrimary: ColorLibrary.raspberry,
    serviceIconAccent: ColorLibrary.raspberry,
    bannerBg: ColorLibrary.blush,
    link: ColorLibrary.raspberry,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.blush,
    serviceDetailCardAccentBg: ColorLibrary.raspberry,
    serviceDetailCardText: ColorLibrary.raspberry,
    serviceDetailCardAccentText: ColorLibrary.blush,
    welcomeScreenSlideCurrentDot: ColorLibrary.raspberry,
    welcomeScreenSlideInvertedDot: ColorLibrary.silver,
    welcomeScreenBackgroundSlide0: ColorLibrary.white,
    welcomeScreenBackgroundSlide1: ColorLibrary.white,
    welcomeScreenBackgroundSlide2: ColorLibrary.white,
    welcomeScreenBackgroundSlide3: ColorLibrary.white,

    // Button Colours
    buttonPrimary: ColorLibrary.raspberry,

    // Slider Colours
    sliderPrimary: ColorLibrary.raspberry,

    // TODO: Refactor/Deprecate
    buttonSecondaryActive: ColorLibrary.raspberryLight,
  },
}

export const ccqDark: DefaultTheme = {
  name: 'ccq Dark',
  ...baseTheme,
  colors: {
    ...baseColors,
    background: ColorLibrary.charcoal,
    text: ColorLibrary.linen,
    textInverted: ColorLibrary.charcoal,
    textSecondary: ColorLibrary.linen,
    primary: ColorLibrary.ccqTeal,
    primaryText: ColorLibrary.charcoal,
    secondary: ColorLibrary.linen,
    accent: ColorLibrary.ccqTeal,
    selected: ColorLibrary.dimGray,
    errorText: ColorLibrary.alert,
    gradientStart: ColorLibrary.tealLight,
    gradientEnd: ColorLibrary.raspberryLight,
    elementsBg: ColorLibrary.darkSlate,
    elementsBorder: ColorLibrary.dimGray,
    contrastElementBg: ColorLibrary.dimGray,
    tagBg: ColorLibrary.dirtyLinen,
    dim: ColorLibrary.linen,
    practitionerMsgBg: ColorLibrary.darkSlate,
    todayHeaderActionIcon: ColorLibrary.silver,
    clientCardBg: ColorLibrary.darkSlate,
    scaleTrackBg: ColorLibrary.dimGray,
    darkText: ColorLibrary.charcoal,
    serviceIconPrimary: ColorLibrary.ccqTeal,
    serviceIconAccent: ColorLibrary.ccqTeal,
    bannerBg: ColorLibrary.darkSlate,
    link: ColorLibrary.ccqTeal,
    appointmentDateElement: ColorLibrary.blush,
    serviceDetailCardBg: ColorLibrary.darkSlate,
    serviceDetailCardAccentBg: ColorLibrary.darkSlate,
    serviceDetailCardText: ColorLibrary.linen,
    serviceDetailCardAccentText: ColorLibrary.linen,
    welcomeScreenSlideCurrentDot: ColorLibrary.ccqTeal,
    welcomeScreenSlideInvertedDot: ColorLibrary.dimGray,
    welcomeScreenBackgroundSlide0: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide1: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide2: ColorLibrary.charcoal,
    welcomeScreenBackgroundSlide3: ColorLibrary.charcoal,

    // Button Colours
    buttonPrimary: ColorLibrary.ccqTeal,
    buttonPrimarySelected: ColorLibrary.dirtyLinen,
    buttonPrimaryDisabled: ColorLibrary.darkSlate,
    buttonPrimaryTextDisabled: ColorLibrary.cement,
    buttonSecondary: ColorLibrary.linen,
    buttonSecondaryText: ColorLibrary.linen,
    buttonSecondaryOutline: ColorLibrary.dimGray,
    buttonSecondaryBorderDisabled: ColorLibrary.darkSlate,

    // Slider Colours
    sliderPrimary: ColorLibrary.ccqTeal,
    sliderSecondary: ColorLibrary.charcoal,

    // TODO: Refactor/Deprecate
    buttonSelected: ColorLibrary.darkSlate,
    buttonSecondarySolid: ColorLibrary.charcoal,
    buttonSecondaryActive: ColorLibrary.tealLight,
  },
}
